import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './assets/css/tailwind.css'
import './assets/fonts/fontawesome/css/all.css'

import VueDragResize from 'vue-drag-resize'

createApp(App)
    .use(store)
    .use(router)
    .component('vue-drag-resize', VueDragResize)
    .mount('#app')
